var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.ticket.id)?_c('TicketDetails'):_vm._e(),(_vm.ticket.id)?_c('TicketActions'):_vm._e(),(_vm.ticket.id)?_c('TicketNotifications'):_vm._e(),(_vm.ticket.id)?_c('TicketBody'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }